<ion-row class="rowPanel">
  <ion-col size="6">
    <div class="canvasCol">
      <canvas baseChart #myChart id="gaugeChart"></canvas>
    </div>
  </ion-col>
  <ion-col size="6" class="legend">
    @for (bar of gaugeData(); track gaugeData()) {
      <div class="align">
        <span class="rectangle" [ngStyle]="{ 'background-color': bar.color }"></span>
        {{ bar.name | translate }} ({{ bar.minutes | durationGauge }})
      </div>
    }
  </ion-col>
</ion-row>
